import filterOutCanceledAndCurrentRdvs from "./filterOutCanceledAndCurrentRdvs.js";
import { findNextRdv } from "./findNextAndPreviousRdvs.js";
import findEmptySpaceBetweenRdvs from "./findEmptySpaceBetweenRdvs.js";
//calcule le temps disponible entre l'heure proposée et le rdv suivant dans la plage
//on peut fournir un rdv optionnel qui correspond au rdv en cours d'édition, dans le cas d'un editrdv
const getAvailableTime = (heure_proposed, rdvsDeLaPlage, plage, rdv) => {
    const plageEnd = plage.end;
    const proposedRdv = { duration: 0, ...heure_proposed };
    const rdvsDuJourFiltered = filterOutCanceledAndCurrentRdvs(rdvsDeLaPlage, rdv || { id: "" });
    const nextRdv = findNextRdv(proposedRdv, rdvsDuJourFiltered);
    return findEmptySpaceBetweenRdvs(proposedRdv, nextRdv ? nextRdv : plageEnd);
};
export default getAvailableTime;
//# sourceMappingURL=availableTime.js.map